import { render, staticRenderFns } from "./detaiInfo.vue?vue&type=template&id=029a267d&scoped=true&"
import script from "./detaiInfo.vue?vue&type=script&lang=js&"
export * from "./detaiInfo.vue?vue&type=script&lang=js&"
import style0 from "./detaiInfo.vue?vue&type=style&index=0&id=029a267d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "029a267d",
  null
  
)

export default component.exports